import React from "react";
import { mobileDevelopmentData } from "../data/software-apps";
import MobileDevelopmentIcon from "../icons/mobile-development";

const MobileDevelopment = () => {
  return (
    <div className="row align-items-center" id="mobile-development">
      <div className="col-12 col-lg-6 order-2 order-md-1">
        <div className="row align-items-center">
          <div className="col-12 col-md-6">
            {mobileDevelopmentData.slice(0, 2).map((info, index) => (
              <div
                key={index}
                className="text-center digital-card border px-4 py-5 my-4 rounded"
              >
                <img
                  src={info.img}
                  loading="lazy"
                  alt={info.title}
                  className="img-fluid software-and-apps-img card-design-2"
                />
                <h3 className="gilroy-bold mt-4">{info.title}</h3>
              </div>
            ))}
          </div>
          <div className="col-12 col-md-6">
            {mobileDevelopmentData.slice(2, 3).map((info, index) => (
              <div
                key={index}
                className="text-center digital-card border px-4 py-5 rounded"
              >
                <img
                  src={info.img}
                  loading="lzy"
                  alt={info.title}
                  className="img-fluid software-and-apps-img crad-design-2"
                />
                <h3 className="gilroy-bold mt-4">{info.title}</h3>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="col-12 col-lg-6 text-center text-lg-end order-1 order-md-2">
        <MobileDevelopmentIcon />
        <h2 className="fs-56 lh-64 text-danger gilroy-bold py-5">
          Mobile Development
        </h2>
        <p className="fs-16 text-align-justify">
          Mobile development Envision having a portable app that works like your
          favorite ones. We'll assist you plan, create, and distribute an iOS or
          Android computer program that will get common recognition for its
          client encounter - we've done it some time recently with different
          complex ventures. It can be a component-based local app, a half breed,
          or a PWA that will keep your clients coming back. One way or the
          other, our custom program advancement administrations will fit right
          in
        </p>
      </div>
    </div>
  );
};

export default MobileDevelopment;
